import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useCallback, useMemo, useRef, useState } from 'react';
import { useMapEvents } from 'react-leaflet';
import { preventDefault, useBox } from 'shared/hooks/utils';
import { debounce } from 'throttle-debounce';
import * as classnames from 'classnames';
import { DevicePopupInfo } from 'entities/device.map.popup/ui/device-popup-info';
export const DevicesPopup = memo(function DevicesPopup(props) {
    const { devices } = props;
    const boxedDevices = useBox(devices);
    const [devices_under_cursor, setDevicesUnderCursor] = useState([]);
    const boxed_devices_under_cursor = useBox(devices_under_cursor);
    const [popupPosition, setPopupPosition] = useState(null);
    const boxed_popupPosition = useBox(popupPosition);
    const searchDevicesUnderCursor = useCallback((pos, loc2container) => {
        const devices_under_cursor = boxedDevices.current.filter((device) => {
            const last_gps = device.last_gps?.[0];
            if (last_gps == null) {
                return false;
            }
            const pix = loc2container([last_gps.x, last_gps.y]);
            if (pix == null) {
                return false;
            }
            return (Math.abs(pos.pix.x - pix.x) <= 20 &&
                Math.abs(pos.pix.y - pix.y) <= 20);
        });
        if (devices_under_cursor.length > 0) {
            setDevicesUnderCursor(devices_under_cursor);
            setPopupPosition(pos.pix);
        }
    }, []);
    const debouncedSearchDevicesUnderCursor = useMemo(() => debounce(400, searchDevicesUnderCursor), [searchDevicesUnderCursor]);
    const devices_popup_container = useRef(null);
    const onMouseMove = useCallback((position, loc2container) => {
        if (boxed_devices_under_cursor.current.length > 0 &&
            devices_popup_container.current != null) {
            const left = boxed_popupPosition.current?.x;
            const top = boxed_popupPosition.current?.y;
            const width = devices_popup_container.current.offsetWidth;
            const height = devices_popup_container.current.offsetHeight;
            if (left != null && top != null) {
                const in_popup = left - 30 <= position.pix.x &&
                    position.pix.x <= left + width + 30 &&
                    top - 30 <= position.pix.y &&
                    position.pix.y <= top + height + 30;
                if (!in_popup) {
                    setDevicesUnderCursor([]);
                }
            }
        }
        else {
            debouncedSearchDevicesUnderCursor(position, loc2container);
        }
    }, [debouncedSearchDevicesUnderCursor]);
    const onMouseMoveFunc = useCallback((ev) => {
        onMouseMove?.({ pix: ev.containerPoint }, (loc) => map.latLngToContainerPoint([loc[1], loc[0]]));
    }, [onMouseMove]);
    const map = useMapEvents({
        mousemove: onMouseMoveFunc,
    });
    if (popupPosition == null) {
        return null;
    }
    return (_jsx("div", { ref: devices_popup_container, onWheelCapture: preventDefault, className: classnames('ui-map-popup', {
            'ui-map-popup-visible': devices_under_cursor.length > 0,
        }), style: {
            zIndex: 401,
            left: popupPosition.x,
            top: popupPosition.y - 16,
        }, children: devices_under_cursor.map((device) => (_jsx(DevicePopupInfo, { device: device, setDevicesUnderCursor: setDevicesUnderCursor }, device.id))) }));
});
